import {
  GET_LOCATION,
  SET_LOCATION  
} from "./customerActionTypes";

const customerActions = (dispatch) => {
  const getLocation = async () => {
    var response = await _getLocation();
    dispatch({
      type: GET_LOCATION,
      payload: response
    });
  }

  const setLocation = async (geolocation) => {
    dispatch({
      type: SET_LOCATION,
      payload: geolocation
    });
  }
  return { getLocation,setLocation };
};

const _getLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (geolocation => {
          resolve({ geolocation, succes: true });
        }
        ), 
        (code, message) => {
          resolve({success: false, message});
        });
    } else {
      resolve({ success: false, message: "not supported in browser" });
    }
  });
}

export default customerActions;